import React, { useEffect, useState } from "react";
import "./styles.css";
import { Switch } from "@mui/material";
import Icons from "../../../../Config/Images";
import { getCityStateDistrictByPinCode } from "../../../../Store/Action/onboardingAction";
import { useDispatch } from "react-redux";
import {
  addAddressApi,
  getUserAddressTypeAPI,
} from "../../../../Store/Action/addressAction";
import { toast } from "react-toastify";
import { getLoggedInUserDetailsAPI } from "../../../../Store/Action/UserAction";

const AddAddressModal = ({ onClose, onFetchUserAddress }) => {
  const dispatch = useDispatch();
  const [billingSameAsShipping, setBillingSameAsShipping] = useState(true);

  // State to capture input values
  const [shippingData, setShippingData] = useState({
    name: "",
    mobile: "",
    building: "",
    pinCode: "",
    landmark: "",
    city: "",
    state: "",
  });
  const [loggedInUserData, setLoggedInUserData] = useState({});

  const [errorMessage, setErrorMessage] = useState({});

  const [errorMessageBilling, setErrorMessageBilling] = useState("");
  const [borderColor, setBorderColor] = useState("#d3d3d3");
  const [borderColorBilling, setBorderColorBilling] = useState("#d3d3d3");
  const [billingData, setBillingData] = useState({
    name: "",
    mobile: "",
    building: "",
    pinCode: "",
    landmark: "",
    city: "",
    state: "",
  });

  const toggleBillingAddress = () => {
    setBillingSameAsShipping(!billingSameAsShipping);
  };

  const [userAddressTypeData, setUserAddressTypeData] = useState([]);

  const shippingAddressType = userAddressTypeData?.find(
    (e) => e?.address_type_name?.toLowerCase() === "shipping",
  );
  const billingAddressType = userAddressTypeData?.find(
    (e) => e?.address_type_name?.toLowerCase() === "billing",
  );

  // Handle input change for both shipping and billing
  const handleInputChange = (e, type) => {
    const { name, value } = e.target;
    const numericFields = ["mobile", "pinCode"];
    const cleanedValue = numericFields.includes(name)
      ? value.replace(/\D/g, "")
      : value;

    if (type === "shipping") {
      setShippingData((prev) => ({
        ...prev,
        [name]: cleanedValue || null,
      }));
      setErrorMessage((prev) => ({
        ...prev,
        [name]: "",
      }));
    } else {
      setBillingData((prev) => ({
        ...prev,
        [name]: cleanedValue || null,
      }));
      setErrorMessageBilling((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  // Validation function
  const validateAddress = (data, type) => {
    let isValid = true;
    const newErrors = {};
    const requiredFields = [
      "name",
      "mobile",
      "building",
      "pinCode",
      "landmark",
      // "city",
      // "state",
    ];

    requiredFields.forEach((field) => {
      if (!data[field]?.toString().trim()) {
        newErrors[field] = `${field.replace(/([A-Z])/g, " $1")} is required`;
        isValid = false;
      }
    });

    if (data?.mobile && !/^[6-9]\d{9}$/.test(data?.mobile)) {
      newErrors.mobile = "Please enter a valid 10-digit mobile number";
      isValid = false;
    }

    if (data?.pinCode && !/^[1-9][0-9]{5}$/.test(data?.pinCode)) {
      newErrors.pinCode = "Please enter a valid pin code";
      isValid = false;
    }

    if (type === "shipping") {
      setErrorMessage(newErrors);
    } else {
      setErrorMessageBilling(newErrors);
    }

    return isValid;
  };

  // const handleMobileNumberChange = (e, addressType) => {
  //   const { value } = e.target;

  //   // Update the state for the corresponding address type
  //   if (addressType === "shipping") {
  //     setShippingData((prev) => ({ ...prev, mobile: value }));
  //   } else {
  //     setBillingData((prev) => ({ ...prev, mobile: value }));
  //   }
  //   setErrorMessage("");
  //   setBorderColor("#d3d3d3");
  // };

  // const handlePinCodeChange = (text, addressType) => {
  //   if (addressType === "shipping") {
  //     setShippingData((prev) => ({ ...prev, pinCode: text }));
  //   } else {
  //     setBillingData((prev) => ({ ...prev, pinCode: text }));
  //   }
  //   setErrorMessage("");
  //   setBorderColor("#d3d3d3");
  //   if (text?.length === 6) {
  //     dispatch(
  //       getCityStateDistrictByPinCode(text, (result) => {
  //         if (addressType === "shipping") {
  //           setShippingData((prev) => ({
  //             ...prev,
  //             state: result?.state || "",
  //             city: result?.city || "",
  //           }));
  //         } else {
  //           setBillingData((prev) => ({
  //             ...prev,
  //             state: result?.state || "",
  //             city: result?.city || "",
  //           }));
  //         }
  //       })
  //     );
  //   }
  // };

  // Handle form submission

  const handleMouseOutForPinCode = (e, type) => {
    const pinCode =
      type === "shipping" ? shippingData.pinCode : billingData.pinCode;
    dispatch(
      getCityStateDistrictByPinCode(pinCode, (result) => {
        if (result?.status) {
          if (type === "shipping") {
            setShippingData((prev) => ({
              ...prev,
              state: result?.data?.user_state || prev.state,
              city: result?.data?.user_city || prev.city,
              // district: result?.data?.user_district,
            }));
          } else {
            setBillingData((prev) => ({
              ...prev,
              state: result?.data?.user_state || prev.state,
              city: result?.data?.user_city || prev.city,
              // district: result?.data?.user_district,
            }));
          }
        }
      }),
    );
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Validate shipping and billing addresses
    const isShippingValid = validateAddress(shippingData, "shipping");
    const isBillingValid = billingSameAsShipping
      ? true
      : validateAddress(billingData, "billing");

    if (!isShippingValid || !isBillingValid) return;

    const requestData = {
      address_type_id: shippingAddressType?.address_type_id,
      isSameAsShipping: billingSameAsShipping,
      user_first_name: shippingData.name?.split(" ")[0] || null,
      user_last_name: shippingData.name?.split(" ")[1],
      company_name: null,
      user_mobile_number: shippingData.mobile || null,
      user_address_1: shippingData.building || null,
      user_address_2: shippingData.landmark || null,
      city: shippingData.city || null,
      state: shippingData.state || null,
      zip_code: shippingData.pinCode || null,
      country: "india",
      delivery_instructions: null,
    };

    if (!billingSameAsShipping) {
      Object.assign(requestData, {
        billing_address_type_id: billingAddressType?.address_type_id,
        billing_first_name: billingData.name?.split(" ")[0] || null,
        billing_last_name: billingData.name?.split(" ")[1],
        billing_mobile_number: billingData.mobile || null,
        billing_address_1: billingData.building || null,
        billing_address_2: billingData.landmark || null,
        billing_city: billingData.city || null,
        billing_state: billingData.state || null,
        billing_zip_code: billingData.pinCode || null,
        billing_country: "india",
        billing_delivery_instructions: null,
      });
    }

    try {
      dispatch(
        addAddressApi(requestData, (isSuccess, result) => {
          if (result?.status) {
            // Clear any previous error messages if the mobile number is valid
            setErrorMessage("");
            setBorderColor("#DFDFDF");
            onFetchUserAddress();
            toast.success(result?.message?.message);
            onClose();
          } else {
            toast.error(result?.error?.message);
          }
        }),
      );
    } catch (error) {}
  };

  useEffect(() => {
    dispatch(
      getLoggedInUserDetailsAPI({}, (res) => {
        const user = res?.data?.[0];

        setLoggedInUserData(user);
      }),
    );
  }, [dispatch]);

  useEffect(() => {
    dispatch(
      getUserAddressTypeAPI({}, (result) => {
        setUserAddressTypeData(result);
      }),
    );
  }, [dispatch]);

  useEffect(() => {
    if (loggedInUserData) {
      const fullName =
        `${loggedInUserData.user_first_name || ""} ${loggedInUserData.user_last_name || ""}`.trim();

      const prefillData = {
        name: fullName,
        mobile: loggedInUserData.user_mobile_number || "",
        building: loggedInUserData.user_address || "",
        pinCode: loggedInUserData.user_pin_code || "",
        landmark: "", // no field in API
        city: loggedInUserData.user_city || "",
        state: loggedInUserData.user_state || "",
      };

      setShippingData(prefillData);

      // Optional: also prefill billing if toggle is ON
      if (billingSameAsShipping) {
        setBillingData(prefillData);
      }
    }
  }, [loggedInUserData]);
  
  useEffect(() => {
    if (billingSameAsShipping) {
      setBillingData(shippingData);
    }
  }, [billingSameAsShipping, shippingData]);

  return (
    <div className="modal-address-overlay">
      <div className="modal-address-content">
        <img
          onClick={onClose}
          src={Icons.circleCloseIcon}
          className="circle-close-icon"
          alt=""
        />
        <h3 className="modal-title">Add Address</h3>
        <p className="modal-subtitle">Shipping Address</p>
        <form className="form-container" onSubmit={handleSubmit}>
          <div className="form-row">
            <div className="extra-divv">
              <div className="inner-extraa-divv">
                <div className="inner-inp-div">
                  <input
                    type="text"
                    placeholder="Name"
                    className="input-field"
                    name="name"
                    value={shippingData.name}
                    onChange={(e) => handleInputChange(e, "shipping")}
                  />
                </div>
                {errorMessage && (
                  <div
                    style={{
                      color: "red",
                      // marginTop: "5px",
                      textAlign: "left",
                      fontSize: "14px",
                    }}
                  >
                    {errorMessage?.name}
                  </div>
                )}
              </div>
            </div>

            <div className="extra-divv">
              <div className="inner-extraa-divv">
                <div className="inner-inp-div">
                  <input
                    type="text"
                    placeholder="Mobile Number"
                    className="input-field"
                    name="mobile"
                    value={shippingData.mobile || ""}
                    // onChange={(e) => handleMobileNumberChange(e, "shipping")}
                    onChange={(e) => handleInputChange(e, "shipping")}
                    maxLength={10}
                    onFocus={() => setBorderColor("#b47e2e")} // Set border color on focus
                    onBlur={() => setBorderColor("#d3d3d3")} // Set border color on blur
                  />
                </div>

                {errorMessage && (
                  <div
                    style={{
                      color: "red",
                      // marginTop: "5px",
                      textAlign: "left",
                      fontSize: "14px",
                    }}
                  >
                    {errorMessage?.mobile}
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="form-row">
            <div className="extra-divv">
              <div className="inner-extraa-divv">
                <div className="inner-inp-div">
                  <input
                    type="text"
                    placeholder="Enter Building, Street Name"
                    className="input-field"
                    name="building"
                    value={shippingData.building}
                    onChange={(e) => handleInputChange(e, "shipping")}
                  />
                </div>
                {errorMessage && (
                  <div
                    style={{
                      color: "red",
                      // marginTop: "5px",
                      textAlign: "left",
                      fontSize: "14px",
                    }}
                  >
                    {errorMessage?.building}
                  </div>
                )}
              </div>
            </div>
            <div className="extra-divv">
              <div className="inner-extraa-divv">
                <div className="inner-inp-div">
                  <input
                    type="text"
                    maxLength={6}
                    placeholder="Enter Pin Code"
                    className="input-field"
                    name="pinCode"
                    value={shippingData.pinCode || ""}
                    // onChange={(e) =>
                    //   handlePinCodeChange(e.target.value, "shipping")
                    // }
                    onChange={(e) => handleInputChange(e, "shipping")}
                    onKeyUp={(e) => {
                      handleMouseOutForPinCode(e, "shipping");
                      // handleFormFieldChange(e);
                    }}
                  />
                </div>
                {errorMessage && (
                  <div
                    style={{
                      color: "red",
                      // marginTop: "5px",
                      textAlign: "left",
                      fontSize: "14px",
                    }}
                  >
                    {errorMessage?.pinCode}
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="form-row">
            <div className="extra-divv">
              <div className="inner-extraa-divv">
                <div className="inner-inp-div">
                  <input
                    type="text"
                    placeholder="Enter Landmark"
                    className="input-field"
                    name="landmark"
                    value={shippingData.landmark}
                    onChange={(e) => handleInputChange(e, "shipping")}
                  />
                </div>
                {errorMessage && (
                  <div
                    style={{
                      color: "red",
                      // marginTop: "5px",
                      textAlign: "left",
                      fontSize: "14px",
                    }}
                  >
                    {errorMessage?.landmark}
                  </div>
                )}
              </div>
            </div>
            <div className="extra-divv">
              <div className="inner-extraa-divv">
                <div className="inner-inp-div">
                  <input
                    type="text"
                    placeholder="Enter City"
                    className="input-field"
                    name="city"
                    value={shippingData.city}
                    onChange={(e) => handleInputChange(e, "shipping")}
                  />
                </div>
                {/* {errorMessage && (
                  <div
                    style={{
                      color: "red",
                      // marginTop: "5px",
                      textAlign: "left",
                      fontSize: "14px",
                    }}
                  >
                    {errorMessage?.city}
                  </div>
                )} */}
              </div>
            </div>
          </div>
          <div className="form-row">
            <div className="extra-divv">
              <div className="inner-extraa-divv">
                <div className="inner-inp-div">
                  <input
                    type="text"
                    placeholder="Enter State"
                    className="input-field"
                    name="state"
                    value={shippingData.state}
                    onChange={(e) => handleInputChange(e, "shipping")}
                  />{" "}
                </div>
                {/* {errorMessage && (
                  <div
                    style={{
                      color: "red",
                      // marginTop: "5px",
                      textAlign: "left",
                      fontSize: "14px",
                    }}
                  >
                    {errorMessage?.state}
                  </div>
                )} */}
              </div>
            </div>
            <div className="billing-toggle">
              <p className="billing-same-text">
                Billing Address <br /> Same As per Shipping
              </p>
              <Switch
                checked={billingSameAsShipping}
                onChange={toggleBillingAddress}
                sx={{
                  "& .MuiSwitch-track": {
                    background:
                      "linear-gradient(180deg, #E8EAEA 0%, #FFFFFF 100%)", // Light gradient for unchecked state
                    opacity: 1,
                  },
                  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                    background:
                      "linear-gradient(180deg, #B88A35 0%, #855E2A 100%)", // Golden gradient for checked state
                    opacity: 1,
                  },
                  "& .MuiSwitch-thumb": {
                    background:
                      "linear-gradient(180deg, #FFFFFF 0%, #E8EAEA 100%)", // Light gradient for thumb in unchecked state
                  },
                  "& .MuiSwitch-switchBase.Mui-checked .MuiSwitch-thumb": {
                    background: "#FFFFFF", // Solid white for thumb when checked
                  },
                }}
              />
            </div>
          </div>
        </form>

        {!billingSameAsShipping && (
          <>
            <p className="modal-subtitle">Billing Address</p>
            <form className="form-container">
              <div className="form-row">
                <div className="extra-divv">
                  <div className="inner-extraa-divv">
                    <div className="inner-inp-div">
                      <input
                        type="text"
                        placeholder="Name"
                        className="input-field"
                        name="name"
                        value={billingData.name}
                        onChange={(e) => handleInputChange(e, "billing")}
                      />
                    </div>
                    {errorMessage && (
                      <div
                        style={{
                          color: "red",
                          // marginTop: "5px",
                          textAlign: "left",
                          fontSize: "14px",
                        }}
                      >
                        {errorMessage?.name}
                      </div>
                    )}
                  </div>
                </div>

                <div className="extra-divv">
                  <div className="inner-extraa-divv">
                    <div className="inner-inp-div">
                      <input
                        type="text"
                        placeholder="Mobile Number"
                        className="input-field"
                        name="mobile"
                        value={billingData.mobile || ""}
                        // onChange={(e) => handleMobileNumberChange(e, "billing")}
                        onChange={(e) => handleInputChange(e, "billing")}
                        maxLength={10}
                        onFocus={() => setBorderColor("#b47e2e")} // Set border color on focus
                        onBlur={() => setBorderColor("#d3d3d3")} // Set border color on blur
                      />
                    </div>
                    {errorMessageBilling && (
                      <div
                        style={{
                          color: "red",
                          // marginTop: "5px",
                          textAlign: "left",
                          fontSize: "14px",
                        }}
                      >
                        {errorMessageBilling?.mobile || ""}
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="form-row">
                <div className="extra-divv">
                  <div className="inner-extraa-divv">
                    <div className="inner-inp-div">
                      <input
                        type="text"
                        placeholder="Enter Building, Street Name"
                        className="input-field"
                        name="building"
                        value={billingData.building}
                        onChange={(e) => handleInputChange(e, "billing")}
                      />
                    </div>
                    {errorMessage && (
                      <div
                        style={{
                          color: "red",
                          // marginTop: "5px",
                          textAlign: "left",
                          fontSize: "14px",
                        }}
                      >
                        {errorMessage?.building}
                      </div>
                    )}
                  </div>
                </div>
                <div className="extra-divv">
                  <div className="inner-extraa-divv">
                    <div className="inner-inp-div">
                      <input
                        type="text"
                        maxLength={6}
                        placeholder="Enter Pin Code"
                        className="input-field"
                        name="pinCode"
                        value={billingData.pinCode || ""}
                        // onChange={(e) =>
                        //   handlePinCodeChange(e.target.value, "billing")
                        // }
                        onChange={(e) => handleInputChange(e, "billing")}
                        onKeyUp={(e) => {
                          handleMouseOutForPinCode(e, "billing");
                          // handleFormFieldChange(e);
                        }}
                      />
                    </div>
                    {errorMessageBilling && (
                      <div
                        style={{
                          color: "red",
                          // marginTop: "5px",
                          textAlign: "left",
                          fontSize: "14px",
                        }}
                      >
                        {errorMessageBilling?.pinCode}
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="form-row">
                <div className="extra-divv">
                  <div className="inner-extraa-divv">
                    <div className="inner-inp-div">
                      <input
                        type="text"
                        placeholder="Enter Landmark"
                        className="input-field"
                        name="landmark"
                        value={billingData.landmark}
                        onChange={(e) => handleInputChange(e, "billing")}
                      />
                    </div>
                    {errorMessage && (
                      <div
                        style={{
                          color: "red",
                          // marginTop: "5px",
                          textAlign: "left",
                          fontSize: "14px",
                        }}
                      >
                        {errorMessage?.landmark}
                      </div>
                    )}
                  </div>
                </div>
                <div className="extra-divv">
                  <div className="inner-extraa-divv">
                    <div className="inner-inp-div">
                      <input
                        type="text"
                        placeholder="Enter City"
                        className="input-field"
                        name="city"
                        value={billingData.city}
                        onChange={(e) => handleInputChange(e, "billing")}
                      />
                    </div>
                    {/* {errorMessage && (
                      <div
                        style={{
                          color: "red",
                          // marginTop: "5px",
                          textAlign: "left",
                          fontSize: "14px",
                        }}
                      >
                        {errorMessage?.city}
                      </div>
                    )} */}
                  </div>
                </div>
              </div>
              <div className="form-row">
                <div className="extra-divv">
                  <div className="inner-extraa-divv">
                    <div className="inner-inp-div">
                      <input
                        type="text"
                        placeholder="Enter State"
                        className="input-field"
                        name="state"
                        value={billingData.state}
                        onChange={(e) => handleInputChange(e, "billing")}
                      />
                    </div>
                    {/* {errorMessage && (
                      <div
                        style={{
                          color: "red",
                          // marginTop: "5px",
                          textAlign: "left",
                          fontSize: "14px",
                        }}
                      >
                        {errorMessage?.state}
                      </div>
                    )} */}
                  </div>
                </div>
              </div>
            </form>
          </>
        )}

        <button type="submit" className="save-button" onClick={handleSubmit}>
          Save
        </button>
      </div>
    </div>
  );
};

export default AddAddressModal;
